var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        visible: _vm.showModal,
        "is-loading": _vm.isLoading,
        "is-submiting": _vm.isSubmiting,
        disabled: !_vm.selectedId,
        title: "Logar como distribuidor",
        description: "Deseja realmente logar como distribuidor?",
        "confirm-text": "Confirmar",
        "cancel-text": "Cancelar",
        icon: "el-icon-check",
        "confirm-type": "success",
        "tag-type": "success"
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        cancel: _vm.toggleModal,
        confirm: _vm.onSubmit,
        closed: _vm.resetModal
      }
    },
    [
      _vm.payload
        ? _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("i", { staticClass: "el-icon-right" }),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-bold ml-2" }, [
              _vm._v(_vm._s(_vm.payload.nome))
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e6de756", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6de756","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorLoginAs.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5e6de756","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorLoginAs.vue
// module chunks = 2